module.exports = __webpack_public_path__ + "static/media/instruction_waist.2edc9187.webp";